'use client'
import React from 'react'
import Link from 'next/link'
import Image from 'next/image'

import AmyContainer from '@/components/UI/AmyContainer/AmyContainer'
import Grid from '@/components/UI/Grid/Grid'
import {Body4, Body5, Body6, Span} from '@/components/UI/Typography'

import AppStoreButton from '../Home/AppStoreButton'
import GooglePlayButton from '../Home/GooglePlayButton'
import Icon from '../UI/Icon/Icon'
import Box from '../UI/Box/Box'

const Footer = () => (
  <Box className="justify-center items-center  w-full bg-primary relative">
    <Box className="bg-[url(/footer-lines.png)] bg-bottom bg-cover opacity-40 w-full h-full absolute top-0 left-0 lg:flex hidden" />
    <AmyContainer className="z-10 py-8">
      <Grid container className="lg:gap-y-12">
        <Grid className="relative lg:col-span-3 col-span-12 flex flex-col items-center">
          <Image
            className="absolute left-1/2 -translate-x-1/2"
            width={70}
            height={70}
            alt="advicemy-footer"
            src="/Vector-A.png"
          />
          <Box className="relative lg:w-52 lg:h-12 w-72 h-16">
            <Image fill alt="logo" src="/advicemy_white_grey.png" />
          </Box>
        </Grid>
        <Grid className="lg:col-span-3 col-span-12 flex flex-col items-center">
          <Link href="/nasil-calisiyor/" aria-label="Go to how it works page">
            <Body5 className="text-white">Nasıl Çalışıyor ?</Body5>
          </Link>
          <Link href="/hakkimizda" aria-label="Go to about us page">
            <Body5 className="text-white">Hakkımızda</Body5>
          </Link>
          <Link href="/iletisim" aria-label="Go to contact page">
            <Body5 className="text-white">İletişim</Body5>
          </Link>
          <Link href="/blog" aria-label="Go to blog page">
            <Body5 className="text-white">Blog</Body5>
          </Link>
        </Grid>
        <Grid className="lg:col-span-3 col-span-12 flex flex-col items-center">
          <Link
            href="/sartlar-ve-kosullar"
            aria-label="Go to terms of use page">
            <Body5 className="text-white">Kullanım Şartları</Body5>
          </Link>
          <Link
            href="/gizlilik-politikasi"
            aria-label="Go to privacy policy page">
            <Body5 className="text-white">Gizlilik Hakları ve KVKK</Body5>
          </Link>
          <Link
            href="/mesafeli-satis-sozlesmesi"
            aria-label="Go to distance sale agreement page">
            <Body5 className="text-white">Mesafeli Satış Sözleşmesi</Body5>
          </Link>
          <Link href="/iade-sureci" aria-label="Go to refund process page">
            <Body5 className="text-white">İade Süreci</Body5>
          </Link>
          <Link href="/cerez-politikasi" aria-label="Go to cookie policy page">
            <Body5 className="text-white">Çerez Politikası</Body5>
          </Link>
        </Grid>
        <Grid className="lg:col-span-3 col-span-12 flex flex-col gap-4 items-center">
          <Box className="flex flex-col">
            <Body4 className="text-white">Bizi Takip Edin</Body4>
            <Box className="gap-2">
              <Link
                href="https://www.facebook.com/advicemyturkey/"
                rel="nofollow"
                target="_blank"
                aria-label="Go to facebook page">
                <Icon className="fill-white" name="facebook" size={36} />
              </Link>
              <Link
                href="https://www.instagram.com/advicemycom/"
                rel="nofollow"
                target="_blank"
                aria-label="Go to instagram page">
                <Icon className="fill-white" name="instagram" size={36} />
              </Link>
              <Link
                href="https://www.linkedin.com/company/advicemycom/"
                rel="nofollow"
                target="_blank"
                aria-label="Go to linkedin page">
                <Icon className="fill-white" name="linkedin" size={36} />
              </Link>
            </Box>
          </Box>
          <Box className="flex flex-col gap-1">
            <GooglePlayButton className="w-32 h-8" />
            <AppStoreButton className="w-32 h-8" />
          </Box>
        </Grid>
        <Grid className="col-span-12">
          <Box className="flex-col max-w-3xl mx-auto gap-2">
            <Body6 className="text-white text-center">
              <Span className="font-bold">Dikkat - </Span>Online danışmanlık
              hizmeti, herkese uygun bir hizmet değildir. İntihar veya kendine
              zarar vermek gibi düşüncelere sahipseniz, sitedeki hizmetler size
              uygun olmayabilir. Bu durumdaysanız aşağıdaki yardım numaraları
              ile iletişime geçmenizi tavsiye ederiz.
            </Body6>
            <Body6 className="text-white text-center">
              Acil Yardım Hattı: <Span className="font-bold">112</Span>, Polis
              İmdat Hattı: <Span className="font-bold">155</Span>, Aile İçi
              Yardım Hattı: <Span className="font-bold">183</Span>, Uyuşturucu
              İle Mücadele Yardım Hattı: <Span className="font-bold">191</Span>
            </Body6>
          </Box>
        </Grid>
      </Grid>
    </AmyContainer>
  </Box>
)

export default Footer
